import React, { useState, useEffect } from "react"
import {
  Card, Col, Row,
} from "reactstrap"
import { useHistory } from "react-router-dom"
import { apiClient } from "../../../api"
import { token, CheckTokenExp, encryptText, encryptAES, encryptDES, encryptMessage } from '../../../config'
import CardDemo from "./CardPackage/CardDemo"
import CardNormal from "./CardPackage/CardNormal"
import CardSpecial from "./CardPackage/CardSpecial"
import CardRecommend from "./CardPackage/CardRecommend"
import CardCustom from "./CardPackage/CardCustom"
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js'
import 'swiper/swiper-bundle.min.css'
import { Navigation, Pagination, Mousewheel } from "swiper"
import "./PackageList.scoped.scss"
import CustomPackage from "./components/CustomPackage"
import JustForYouPackage from "./components/JustForYouPackage"
import ContactUs from "./components/ContactUs"

export default function PackageList() {
  let history = useHistory()
  const [env, setEnv] = useState("")
  const [encryptionEcomKey, setEncryptionEcomKey] = useState(null)
  useEffect(() => {
    getProfile()
    fetchData()
    getSettingJson()
  }, [])

  const getSettingJson = () => {
    apiClient.get('api/function/getappsettings')
      .then((response) => {
        const json = response.data;
        setEncryptionEcomKey(json.encryptionEcomKey)
        setEnv(json.env.name)
      })
      .catch(error => console.error('Error fetching JSON:', error));
  }

  const [data, setData] = useState([])
  const [profile, setProfile] = useState({})

  const onClickToPage = (type, id) => {
    const key = encryptionEcomKey.key; // 16 characters = 16 bytes
    const iv = encryptionEcomKey.iv; // 16 characters = 16 bytes
    const encryptedMessage = encodeURIComponent(encryptMessage(id, key, iv));

    // const encodedData = btoa(id) // encode a string
    history.push(`RequestTaxInfo?type=${type}&pid=${encryptedMessage}`)
  }

  const fetchData = async () => {
    let req = null

    const response = await apiClient.post("api/ecom/getPackagedata", req, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((response) => {

        return response
      })
      .catch((error) => { })
    setData(response.data.PackageList)
  }

  const formatCurrency = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  const getProfile = () => {
    if (!CheckTokenExp()) {
      apiClient.post('api/profile/GetProfile', {}
        , {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        })
        .then(data => {
          var json = data.data[0]

          if (json) {
            setProfile(json)
          }
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      window.location.href = "logout"
    }
  }

  const calculateCreditFromAccPrice = (price) => {
    return Math.ceil(price / profile.creditRate).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  const calculateCreditRatePkg = (price, priceRate) => {
    return Math.ceil(price / priceRate).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  const calcualteCredit = (price, priceRate) => {
    if (env === "ECOM") { //ecom env
      return calculateCreditRatePkg(price, priceRate)
    } else { //all env
      return calculateCreditFromAccPrice(price)
    }
  }

  const ClearCookie = () => {
    var now = new Date()
    var time = now.getTime()
    var expireTime = time
    now.setTime(expireTime)
    document.cookie =
      "__AntiXsrfUerkey=" + "" + ";expires=" + now.toGMTString() + ";path=/"
    // this.props.history.push("/PackageList");
    localStorage.clear()
  }

  return (
    <>
      <div className="package-card">
        <div className="pricing-recommend-header">
          <h2>Recommend</h2>
          <p>Mix and match our channels and products to create a personalized </p>
          <p>solution that fits your unique communication needs.</p>
        </div>
        <div className="pricing-container">
          {data.map((data) => (
            data.PackageType === 1 && (
              data.Package_Recommend ? (
                <div key={data.PackageId} className={`pricing-card pricing-card--dark`}>
                  {data.Package_Recommend && <div className="pricing-card__badge">Recommend</div>}

                  <div className="pricing-card__header">
                    <h3 className="pricing-card__title">{data.PackageName}</h3>
                    <div className="pricing-card__credit">
                      <span className="pricing-card__credit-amount">{data.Packagetotal_message.toLocaleString()}</span>
                      <span className="pricing-card__credit-text">Credit</span>
                    </div>
                    <div className="pricing-card__price-per-credit">{data.PackagePrice_per_credit} ฿/credit</div>
                    <div className="pricing-card__thai-text">เหมาะสำหรับมือใหม่ ทดลองใช้งาน</div>
                  </div>

                  <div className="pricing-card__price">฿ {data.Packagetotal_price.toLocaleString()}</div>

                  <div className="pricing-card__features">
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      Credit period : {data.Package_Packageexpire} Month
                    </div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      Report : {data.Package_Reportexpire} Month
                    </div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      SMS Qty : {data.Packagetotal_message.toLocaleString()}
                    </div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      Sender name : {data.Package_Sender}
                    </div>
                  </div>
                  <div className="pricing-card__button-container">
                    <button
                      className="pricing-card__button"
                      onClick={() => {
                        let pid =
                          data.PackageId + "|" + data.Packagetotal_price;
                        onClickToPage("default", pid)
                      }}
                    >
                      Buy now
                    </button>
                  </div>
                </div>
              ) : (
                <div key={data.PackageId} className={`pricing-card pricing-card--light`}>
                  <div className="pricing-card__header">
                    <h3 className="pricing-card__title">{data.PackageName}</h3>
                    <div className="pricing-card__credit">
                      <span className="pricing-card__credit-amount">{data.Packagetotal_message.toLocaleString()}</span>
                      <span className="pricing-card__credit-text">Credit</span>
                    </div>
                    <div className="pricing-card__price-per-credit">{data.PackagePrice_per_credit} ฿/credit</div>
                    <div className="pricing-card__thai-text">เหมาะสำหรับมือใหม่ ทดลองใช้งาน</div>
                  </div>

                  <div className="pricing-card__features">
                    <div className="pricing-card__price">฿ {data.Packagetotal_price.toLocaleString()}</div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      Credit period : {data.Package_Packageexpire} Month
                    </div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      Report : {data.Package_Reportexpire} Month
                    </div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      SMS Qty : {data.Packagetotal_message.toLocaleString()}
                    </div>
                    <div className="pricing-card__feature">
                      <span className="pricing-card__checkmark">✓</span>
                      Sender name : {data.Package_Sender}
                    </div>

                    <div className="pricing-card__button-container">
                      <button
                        className="pricing-card__button"
                        onClick={() => {
                          let pid =
                            data.PackageId + "|" + data.Packagetotal_price;
                          onClickToPage("default", pid)
                        }}
                      >
                        Buy now
                      </button>
                    </div>
                  </div>
                </div>
              )
            )

          ))}
        </div>
        <CustomPackage onClickToPage={onClickToPage} />
      </div>
      {data.filter(row => row.PackageType === 6).length > 0 && <JustForYouPackage data={data} onClickToPage={onClickToPage} />}
      <ContactUs />
    </>
  )
}
